var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allButton"},_vm._l((_vm.buttonDataItem),function(item){return _c('el-button',{key:item.name,attrs:{"type":"primary","disabled":_vm.buttonDisabled},on:{"click":function($event){return _vm.chooseDropItem(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }